export const shouldLaunchWithFreshSession = (): boolean => {
  return true;
};
